<template>
	<div class="shop-add">
		<el-form ref="form" :model="form" :rules="rules" hide-required-asterisk label-width="160px">
			<div class="base-info-box">
				<div class="title">基础信息</div>
				<el-form-item label="商场" prop="mallId">
					<el-select v-model="form.mallId" placeholder="请选择商场" @change="onMallChange" :disabled="!!form.id"
						filterable>
						<el-option v-for="item in mallData" :key="item.id" :label="item.name"
							:value="item.id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="店铺LOGO" prop="logo">
					<UploadImg name="logo" @getUploadFile="getUploadFile" :uploadUrl="form.logo"
						desc="建议：上传140*140的jpg、png、jpeg的图片"></UploadImg>
				</el-form-item>
				<el-form-item label="店铺背景图" prop="bgLogo">
					<UploadImg name="bgLogo" @getUploadFile="getUploadFile" :uploadUrl="form.bgLogo"
						desc="建议：上传750*320的jpg、png、jpeg的图片"></UploadImg>
				</el-form-item>
				<el-form-item label="店铺名称" prop="name">
					<el-input v-model="form.name" placeholder="请输入店铺名称" />
				</el-form-item>
				<el-form-item label="（选填）外部店铺编号" prop="code">
					<el-input v-model="form.code" placeholder="请输入店铺编号" :disabled="!!$route.query.id" />
				</el-form-item>
				<el-form-item label="选择品牌" prop="brandRefId">
					<el-select v-model="form.brandRefId" placeholder="请选择品牌" :disabled="isBrand" filterable>
						<el-option v-for="(item,index) in brandList" :key="index" :label="item.name"
							:value="item.refId"></el-option>
						<el-option label="新增品牌" value="Add"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="品牌名称" prop="brandName" v-if="form.brandRefId == 'Add'">
					<el-input v-model="form.brandName" placeholder="请输入品牌名称" />
				</el-form-item>
				<el-form-item label="所在楼层" prop="floor">
					<el-select v-model="form.floor" placeholder="请选择所在楼层" filterable>
						<el-option v-for="item in shopFloorData" :key="item" :label="item" :value="item"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="所属业态" prop="categoryIds">
					<el-cascader v-model="form.categoryIds" placeholder="请选择所属业态" :options="shopCategoryData"
						:props="categoryCascaderProps" clearable ref="category" @change="onCategoryChange">
					</el-cascader>
					<span class="input-remark">（一级二级必选）</span>
				</el-form-item>
				<el-form-item label="（选填）店铺邮箱" prop="email">
					<el-input v-model="form.email" placeholder="请输入店铺邮箱" />
					<span class="input-remark">（对账单会自动发送至本邮箱内）</span>
				</el-form-item>
				<el-form-item label="联系电话" prop="contractorPhone">
					<el-input v-model="form.contractorPhone" placeholder="请输入联系电话"
						oninput="value=value.replace(/[^\d]/g,'')" maxLength="11" />
					<span class="input-remark">（店铺负责人电话）</span>
				</el-form-item>
				<el-form-item label="店铺简介" prop="introduction">
					<el-input v-model="form.introduction" type="textarea" :rows="6" placeholder="请输入店铺简介"
						maxlength="2000" show-word-limit />
				</el-form-item>
				<el-form-item label="是否开启" prop="disable">
					<el-radio-group v-model="form.disable">
						<el-radio :label="false">开启店铺</el-radio>
						<el-radio :label="true">关闭店铺</el-radio>
					</el-radio-group>
				</el-form-item>
			</div>
			<el-divider />

			<div class="open-account-box">
				<div class="title">开户信息</div>
				<div class="auto-wrap-box">
					<div class="left-box">
						<el-form-item label="营业执照" prop="businessLicenseUrl">
							<UploadImg name="businessLicenseUrl" @getUploadFile="getUploadFile"
								:uploadUrl="form.businessLicenseUrl" :width="350" :height="180"
								accept=".jpg, .jpeg, .bmp" desc="支持上传jpg，jpeg，bmp格式"></UploadImg>
						</el-form-item>
					</div>
					<div class="right-box">
						<el-form-item label="联营协议" prop="unionAgrementUrl">
							<UploadFile name="unionAgrementUrl" @getUploadFile="getUploadFile"
								:uploadUrl="form.unionAgrementUrl" :width="180" :height="180" accept=".doc, .docx, .pdf"
								desc="支持上传doc，docx，pdf格式"></UploadFile>
						</el-form-item>
					</div>
				</div>
				<el-form-item label="结算方式" prop="accountType">
					<el-select v-model="form.accountType" placeholder="请选择结算方式">
						<el-option label="对公" value="对公"></el-option>
						<el-option label="对私" value="对私"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="主体名称" prop="financeName">
					<el-input v-model="form.financeName" placeholder="请输入主体名称" />
				</el-form-item>
				<el-form-item label="银行名称" prop="bankCode">
					<el-select v-model="form.bankCode" placeholder="请选择银行名称" filterable>
						<el-option v-for="item in bankNameData" :key="item.code" :label="item.name"
							:value="item.code"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="银行账号" prop="bankcardNo">
					<el-input v-model="form.bankcardNo" placeholder="请输入银行账号"
						oninput="value=value.replace(/[^\d]/g,'')" />
				</el-form-item>
				<el-form-item label="联行号" prop="unionBankNo">
					<el-input v-model="form.unionBankNo" placeholder="请输入联行号"
						oninput="value=value.replace(/[^\d]/g,'')" />
				</el-form-item>
				<el-form-item label="开户行" prop="openingbank">
					<el-input v-model="form.openingbank" placeholder="请输入开户行" />
				</el-form-item>
				<el-form-item label="统一社会信用代码" prop="licenceNo">
					<el-input v-model="form.licenceNo" placeholder="请输入统一社会信用代码" />
				</el-form-item>
				<el-form-item label="法人姓名" prop="corporateName">
					<el-input v-model="form.corporateName" placeholder="请输入法人姓名" />
				</el-form-item>
				<el-form-item label="法人身份证号" prop="idCard">
					<el-input v-model="form.idCard" placeholder="请输入法人身份证号" />
				</el-form-item>
				<el-form-item label="法人手机号" prop="phone">
					<el-input v-model="form.phone" placeholder="请输入法人手机号" />
				</el-form-item>
			</div>
			<el-divider />

			<div class="legal-person-box">
				<div class="title">
					<span>法人信息</span>
					<span class="title-remark">（必填）</span>
				</div>
				<div class="auto-wrap-box">
					<div class="left-box">
						<el-form-item label="身份证正面" prop="legalPersonFrontUrl">
							<UploadImg name="legalPersonFrontUrl" @getUploadFile="getUploadFile"
								:uploadUrl="form.legalPersonFrontUrl" :width="350" :height="180"
								accept=".jpg, .jpeg, .bmp" desc="支持上传jpg，jpeg，bmp格式"></UploadImg>
						</el-form-item>
					</div>
					<div class="right-box">
						<el-form-item label="身份证反面" prop="legalPersonbackUrl">
							<UploadImg name="legalPersonbackUrl" @getUploadFile="getUploadFile"
								:uploadUrl="form.legalPersonbackUrl" :width="350" :height="180"
								accept=".jpg, .jpeg, .bmp" desc="支持上传jpg，jpeg，bmp格式"></UploadImg>
						</el-form-item>
					</div>
				</div>
				<div class="auto-wrap-box">
					<div class="left-box">
						<el-form-item label="收款银行卡照片" prop="backCardUrl">
							<UploadImg name="backCardUrl" @getUploadFile="getUploadFile" :uploadUrl="form.backCardUrl"
								:width="350" :height="180" accept=".jpg, .jpeg, .bmp" desc="支持上传jpg，jpeg，bmp格式">
							</UploadImg>
						</el-form-item>
					</div>
				</div>
			</div>
		</el-form>
		<div class="footer">
			<el-button @click="onBack" class="mr20">取消</el-button>
			<el-button type="primary" @click="onSubmit" :loading="submitLoading">提交</el-button>
		</div>
		<!-- <Dialog :maskClose="false" :dialogShow="isShowDialog" title="获取验证码" @maskClick="() => {isShowDialog = false}">
      <div class="verification-form">
        <el-form ref="verificationCode" :model="verificationForm" :rules="verificationRules" hide-required-asterisk label-width="100px">
          <el-form-item label="手机号" prop="phone">
            <el-input v-model="verificationForm.phone_show" :disabled="true" />
          </el-form-item>
          <el-form-item label="验证码" prop="code">
            <div class="verification">
              <el-input v-model="verificationForm.code" placeholder="请输入验证码" oninput="value=value.replace(/[^\d]/g,'')" maxLength="6" />
              <el-button type="primary" :disabled="!!verificationTime" @click="onSendCode">
                <span>发送验证码</span>
                <span v-if="!!verificationTime">({{verificationTime}})s</span>
              </el-button>
            </div>
          </el-form-item>
        </el-form>
        <div class="button-div">
          <el-row class="button-div-row">
            <el-button type="default" class="cancel" @click="() => {isShowDialog = false}">取消</el-button>
            <el-button type="primary" :loading="submitLoading" class="determine" @click="onVerificationSubmit">确定</el-button>
          </el-row>
        </div>
      </div>
    </Dialog> -->
	</div>
</template>

<script>
	import Dialog from "@/components/Dialog/index";
	import UploadImg from '@/components/UploadImg/index'
	import UploadFile from '@/components/UploadFile/index'
	import {
		api_getShopDetailData,
		api_postShopAdd,
		api_putShopEdit,
		api_getFloorData,
		api_getShopPhone,
		api_getShopBankcardNo,
		api_getBrandSelectList
	} from '@/api/finance'
	import {
		api_getConfig,
		api_postFileUpload,
		api_getSendCode,
		api_getVerifyCode
	} from '@/api/common'
	export default {
		name: "shopAdd",
		components: {
			UploadImg,
			UploadFile,
			Dialog
		},
		data() {
			const checkPhone = (rule, value, callback) => {
				const check = /^1\d{10}$/
				if (value && !check.test(value)) {
					callback(new Error('手机号格式有误'))
				} else {
					callback()
				}
			}

			const checkFail = (rule, value, callback) => {
				if (rule.field == 'logo' && !this.form.logo) {
					callback(new Error('请上传店铺LOGO'))
				} else if (rule.field == 'businessLicenseUrl' && !this.form.businessLicenseUrl) {
					callback(new Error('请上传联营协议'))
				} else if (rule.field == 'unionAgrementUrl' && !this.form.unionAgrementUrl) {
					callback(new Error('请上传联营协议'))
				} else if (rule.field == 'bgLogo' && !this.form.bgLogo) {
					callback(new Error('请上传店铺背景图'))
				} else {
					callback()
				}
			}

			const checkImg = (rule, value, callback) => {
				if (rule.field == 'legalPersonFrontUrl' && !this.form
					.legalPersonFrontUrl) {
					console.log('请上传对私结算人身份证人像面', value)
					callback(new Error('请上传身份证正面照 '))
				} else if (rule.field == 'legalPersonbackUrl' && !this.form
					.legalPersonbackUrl) {
					callback(new Error('请上传身份证反面照'))
				} else {
					callback()
				}
			}

			const checkBankImg = (rule, value, callback) => {
				console.log('银行卡片照片验证：', this.accountType, value)
				if (this.form.accountType == '对私' && !value) {
					callback(new Error('请上传收款银行卡照片'))
				} else {
					callback()
				}
			}

			const checkEmail = (rule, value, callback) => {
				const check = /^([a-zA-Z0-9._-])+@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-])+/
				if (value && !check.test(value)) {
					callback(new Error('邮箱格式错误'))
				} else {
					callback()
				}
			}

			return {
				submitLoading: false,
				// isShowDialog: false, // 获取验证码弹窗
				form: {
					disable: false,
					floor: '',
					introduction: ''
				},
				rules: {
					mallId: [{
						required: true,
						message: '请选择商场'
					}],
					logo: [{
						validator: checkFail
					}],
					name: [{
						required: true,
						message: '请输入店铺名称'
					}],
					brandName: [{
						required: true,
						message: '请输入品牌名称'
					}],
					floor: [{
						required: true,
						message: '请选择楼层'
					}],
					categoryIds: [{
						required: true,
						message: '请选择所属业态'
					}],
					contractorPhone: [{
						validator: checkPhone,
						trigger: 'blur'
					}],
					email: [{
						required: true,
						validator: checkEmail
					}],
					contractorPhone: [{
						required: true,
						message: '请输入联系电话'
					}],
					businessLicenseUrl: [{
						validator: checkFail
					}],
					unionAgrementUrl: [{
						validator: checkFail
					}],
					legalPersonFrontUrl: [{
						validator: checkImg
					}],
					legalPersonbackUrl: [{
						validator: checkImg
					}],
					accountType: [{
						required: true,
						message: '请选择结算主体名称'
					}],
					financeName: [{
						required: true,
						message: '请输入主体名称'
					}],
					bankCode: [{
						required: true,
						message: '请选择银行'
					}],
					bankcardNo: [{
						required: true,
						message: '请输入银行账号'
					}],
					unionBankNo: [{
						required: false,
						message: '请输入联行号'
					}],
					openingbank: [{
						required: true,
						message: '请输入开户行'
					}],
					introduction: [{
						required: true,
						message: '请输入店铺简介'
					}],
					bgLogo: [{
						validator: checkFail
					}],
					backCardUrl: [{
						validator: checkBankImg
					}],
					licenceNo: [{
						required: true,
						message: '请输入统一社会信用代码'
					}],
					corporateName: [{
						required: true,
						message: '请输入法人姓名'
					}],
					idCard: [{
						required: true,
						message: '请输入法人身份证号'
					}],
					phone: [{
						required: true,
						message: '请输入法人手机号'
					}],
				},

				verificationTime: 0, // 验证码倒计时
				verificationForm: {}, // 验证码表单
				verificationRules: {
					phone: [{
						required: true,
						message: '请输入手机号'
					}],
				},

				categoryCascaderProps: {
					// checkStrictly: true,
					value: "id",
					label: "name",
					// leaf: "pid"
				},
				mallData: [], // 商场
				brandList: [], //品牌下拉
				shopCategoryData: [], // 所属业态数据
				shopFloorData: [], // 楼层数据
				accountTypeData: [], // 结算主体名称数据
				bankNameData: [], // 银行名称数据
				isBrand: false,
			};
		},
		async created() {
			this.getConfigData() // 获取config
			this.getBrandSelectList()

			if (this.$route.query.id) {
				this.$route.meta.title = '编辑店铺'
				this.id = this.$route.query.id
				await this.getDetailDate() // 获取详情数据
			} else {
				this.$route.meta.title = '录入店铺'
			}
		},
		mounted() {},
		methods: {
			// 获取config
			async getConfigData() {
				const {
					category,
					mall,
					bankcard
				} = await api_getConfig(['category', 'mall', 'bankcard'])
				this.shopCategoryData = category // 所属业态
				this.mallData = mall // 商场
				this.bankNameData = bankcard // 银行
			},

			// 获取详情数据
			async getDetailDate() {
				const {
					baseInfo = {}
				} = await api_getShopDetailData({
					id: this.$route.query.id
				})
				const {
					contractorPhone = ''
				} = await api_getShopPhone({
					storeId: baseInfo.id
				})
				const {
					bankcardNo = ''
				} = await api_getShopBankcardNo({
					financeId: baseInfo.financeId
				})
				this.form = {
					...baseInfo,
					categoryIds: baseInfo.categoryIds ? baseInfo.categoryIds.split(',') : [],
					contractorPhone,
					bankcardNo
				}
				this.isBrand = baseInfo.brandRefId ? true : false
				this.onMallChange(baseInfo.mallId) // 当前商场对应的楼层数据
			},

			getUploadFile(file, name) {
				this.form[name] = file
			},
			//获取品牌列表
			async getBrandSelectList() {
				const res = await api_getBrandSelectList()
				this.brandList = res
			},
			// 业态改变
			onCategoryChange(value) {
				const checkedNode = this.$refs["category"].getCheckedNodes();
				if (checkedNode.length) {
					this.form.category = checkedNode[0].pathLabels.join(',')
				}
			},

			// 商场改变
			onMallChange(value) {
				const {
					floors = []
				} = this.mallData.find(item => item.id == value)
				this.shopFloorData = floors
			},

			// 点击提交按钮
			onSubmit() {
				// this.createdStore()
				this.$refs.form.validate((valid) => {
					if (valid) {
						this.createdStore()
					}
				})
			},

			// 点击发送验证码
			// onSendCode() {
			//   this.$refs.verificationCode.validate(async (valid) => {
			//     if (valid) {
			//       try {
			//         const res = await api_getSendCode({phone: this.verificationForm.phone})
			//         this.$baseMessage('验证码发送成功', 'success')
			//         this.verificationTime = 30
			//         let timer = setInterval(() => {
			//           this.verificationTime = this.verificationTime - 1
			//           if (this.verificationTime <= 0) {
			//             clearInterval(timer)
			//           }
			//         }, 1000)
			//       } catch (err) {
			//         console.log('err: ', err);
			//       }
			//     }
			//   })
			// },

			// 验证码弹窗确定
			// onVerificationSubmit() {
			//   this.$refs.verificationCode.validate(async (valid) => {
			//     if (valid) {
			//       if (!this.verificationForm.code) {
			//         this.$baseMessage('请输入验证码', 'warning')
			//         return
			//       }
			//       const res = await api_getVerifyCode({
			//         code: this.verificationForm.code,
			//         phone: this.verificationForm.phone
			//       })
			//       this.createdStore()
			//     }
			//   })
			// },

			// 创建、编辑店铺
			async createdStore() {
				this.submitLoading = true
				try {
					let params = {
						...this.form,
						categoryIds: this.form.categoryIds ? this.form.categoryIds.join(',') : '',
					}
					// params.brandRefId == 'Add'? :
					if (params.brandRefId && params.brandRefId != 'Add') {
						// this.brandList.map(item => {
						// 	if (item.refId == params.brandRefId) {
						// 		params.brandName = item.name
						// 	}
						// })
					} else {
						delete params.brandRefId
					}

					/* if (this.form.accountType == '对私') {
						if (!this.form.legalPersonFrontUrl || !this.form.legalPersonbackUrl) {
							this.$baseMessage('请上传对私结算人身份证！', 'error')
							this.submitLoading = false
							return;
						}
					} */

					// 上传图片
					if (this.form.logo && this.form.logo.size) {
						const {
							key
						} = await api_postFileUpload(this.form.logo, 'StoreLogo')
						params.logo = key
					}
					if (this.form.bgLogo && this.form.bgLogo.size) {
						const {
							key
						} = await api_postFileUpload(this.form.bgLogo, 'StoreLogo')
						params.bgLogo = key
					}
					if (this.form.businessLicenseUrl && this.form.businessLicenseUrl.size) {
						const {
							key
						} = await api_postFileUpload(this.form.businessLicenseUrl, 'StoreLogo')
						params.businessLicenseUrl = key
					}
					if (this.form.unionAgrementUrl && this.form.unionAgrementUrl.size) {
						const {
							key
						} = await api_postFileUpload(this.form.unionAgrementUrl, 'storeFile')
						params.unionAgrementUrl = key
					}
					if (this.form.legalPersonFrontUrl && this.form.legalPersonFrontUrl.size) {
						const {
							key
						} = await api_postFileUpload(this.form.legalPersonFrontUrl, 'StoreLogo')
						params.legalPersonFrontUrl = key
					}
					if (this.form.legalPersonbackUrl && this.form.legalPersonbackUrl.size) {
						const {
							key
						} = await api_postFileUpload(this.form.legalPersonbackUrl, 'StoreLogo')
						params.legalPersonbackUrl = key
					}
					
					if (this.form.backCardUrl && this.form.backCardUrl.size) {
						const {
							key
						} = await api_postFileUpload(this.form.backCardUrl, 'StoreLogo')
						params.backCardUrl = key
					}

					console.log('params: ', params);
					// return

					params.id ? await api_putShopEdit(params) : await api_postShopAdd(params)
					this.$baseMessage('操作成功', 'success')
					this.onBack()
					this.submitLoading = false
				} catch (error) {
					console.log('error: ', error);
					this.submitLoading = false
				}
			},

			// 返回
			onBack() {
				this.$router.back(-1)
			},
		},
	};
</script>

<style lang="scss" scoped>
	.shop-add {
		width: 100%;
		padding: 35px 20px;
		padding-bottom: 100px;
		box-sizing: border-box;
		position: relative;

		.verification-form {
			padding-top: 50px;

			.el-input {
				width: 90%;
			}

			.verification {
				width: 90%;
				display: flex;
			}

			.button-div {
				margin-top: 50px;

				.button-div-row {
					text-align: right;
				}
			}
		}

		.title {
			margin: 0;
			margin-bottom: 30px;
			padding-left: 15px;
			height: 25px;
			line-height: 25px;
			font-size: 18px;
			font-weight: 500;
			color: #333333;
			position: relative;

			.title-remark {
				color: #666666;
				font-size: 14px;
			}

			&::before {
				position: absolute;
				top: 0;
				left: 0;
				content: '';
				width: 5px;
				height: 25px;
				border-radius: 2px;
				background: #05C8AF;
			}
		}

		.input-remark {
			height: 17px;
			line-height: 17px;
			font-size: 12px;
			color: #999999;
			position: absolute;
			left: 350px;
			bottom: 0;
		}

		.el-input,
		.el-textarea,
		.el-select,
		.el-cascader,
		.el-date-editor {
			width: 350px;
		}

		.auto-wrap-box {
			display: flex;
			flex-wrap: wrap;

			.left-box {
				flex: 1;
			}

			.right-box {
				flex: 1;
			}
		}

		.footer {
			position: fixed;
			bottom: 0;
			padding: 20px 0;
			padding-left: 70px;
			background: #fff;
			width: calc(100vw - #{$base-left-menu-width});
			left: $base-left-menu-width;
		}
	}
</style>